import { store } from "../store";

const home = [
  {
    icon: 'home',
    title: 'Home',
    link: '/',
    items: [
      { title: 'Add' }
    ]
  },
  {
    icon: 'info_outline',
    title: 'About',
    link: '/about'
  },
  {
    icon: 'date_range',
    title: 'Calendar',
    link: '/calendar'
  },
  {
    icon: 'rss_feed',
    title: 'News',
    link: '/news'
  },
  {
    icon: 'person_add',
    title: 'Signup',
    link: '/signup'
  },
  {
    icon: 'fingerprint',
    title: 'Login',
    link: '/login'
  },
]

const admin = [
  {
    icon: 'dashboard',
    title: 'Dashboard',
    link: '/admin'
  },
  {
    icon: 'class',
    title: 'Classroom',
    link: '/admin/classroom'
  },
  {
    icon: 'group',
    title: 'Instructors',
    link: '/admin/instructors'
  },
  {
    icon: 'face',
    title: 'Students',
    link: '/admin/students'
  },
  {
    icon: 'view_headline',
    title: 'News',
    link: '/admin/news'
  },
  {
    icon: 'date_range',
    title: 'Calendar',
    link: '/admin/calendar'
  },
  {
    icon: 'power_settings_new',
    title: 'Logout',
    link: '/logout'
  }
]

const instructor = [
  {
    icon: 'dashboard',
    title: 'Dashboard',
    link: '/instructor'
  },
  {
    icon: 'power_settings_new',
    title: 'Logout',
    link: '/logout'
  },
]

const student = [
  {
    icon: 'dashboard',
    title: 'Dashboard',
    link: '/student'
  },
  {
    icon: 'power_settings_new',
    title: 'Logout',
    link: '/logout'
  },
]

export default {
  home,
  admin,
  instructor,
  student
}


// WEBPACK FOOTER //
// ./src/utils/sidebar.js